import { z } from 'zod';
import { VENDOR_INVOICE_STATUSES } from '../enums.js';
import { objectId, paginationQuery, scopeQuery } from './common.js';
/**
 * The vendor portal's invoice list. Deliberately not `scopeQuery`: a vendor
 * login is scoped by the vendor rows it is linked to, and the only narrowing
 * it can ask for is one of those rows' companies.
 */
export const vendorPortalInvoiceQuery = paginationQuery.extend({
    companyId: objectId.optional(),
    status: z.enum(VENDOR_INVOICE_STATUSES).optional(),
    /** Invoice number, tracking ID or linked PO number. */
    q: scopeQuery.shape.q,
});
//# sourceMappingURL=vendorPortal.js.map